export const GRETA_AI_CHAT_MORE_CHATS_TRIGGER_PX = 400

export const GRETA_AI_CHAT_PAST_WEEK_DAYS = 7

export const GRETA_AI_CHAT_PAST_30_DAYS = 30

export const GretaAIChatChatSectionKey = {
  chats: 'chats',
  older: 'older',
  past30Days: 'past30Days',
  pastWeek: 'pastWeek',
  today: 'today',
}

export const GRETA_AI_CHAT_CHAT_LIST_SECTIONS = [
  { key: GretaAIChatChatSectionKey.today, titleKey: 'Greta.SectionTodayKey' },
  {
    key: GretaAIChatChatSectionKey.pastWeek,
    titleKey: 'Greta.SectionPastWeekKey',
  },
  {
    key: GretaAIChatChatSectionKey.past30Days,
    titleKey: 'Greta.SectionPast30DaysKey',
  },
  { key: GretaAIChatChatSectionKey.older, titleKey: 'Greta.SectionOlderKey' },
]

export const QA_NAME_GRETA_AI_CHAT_CHATS_TOGGLE = 'gretaAIChatChatsToggle'

export const GRETA_AI_CHAT_CHATS_SECTION = {
  key: GretaAIChatChatSectionKey.chats,
  titleKey: 'Greta.ChatsSectionKey',
  toggleQaName: QA_NAME_GRETA_AI_CHAT_CHATS_TOGGLE,
}

export const QA_NAME_GRETA_AI_CHAT_CHAT_LIST = 'gretaAIChatChatList'

export const QA_NAME_GRETA_AI_CHAT_CHAT = 'gretaAIChatChat'

export const QA_NAME_GRETA_AI_CHAT_SEARCH = 'gretaAIChatSearch'

export const QA_NAME_GRETA_AI_CHAT_CHAT_LIST_RETRY = 'gretaAIChatChatListRetry'

export const QA_NAME_GRETA_AI_CHAT_MORE_CHATS_RETRY =
  'gretaAIChatMoreChatsRetry'
